import { render, staticRenderFns } from "./SingleImg.vue?vue&type=template&id=3451cd12&"
import script from "./SingleImg.vue?vue&type=script&lang=js&"
export * from "./SingleImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports